export const LOGIN_PATH = "/login/";
export const REGISTER_PATH = "/register/";
export const HOME_PATH = "/home/";
export const PROJECTS_PATH = "/projects/";
export const PROJECT_DRAW_PATH = "/projects/draw/";
export const ACCOUNT_PATH = "/account/";
export const NEW_USER_FLOW_PATH = "/new-user-flow/";
export const NEW_PROJECT_FLOW = "/new-project-flow/";
export const NEW_PASSWORD = "/login/new-password";
